<header-title [model]="headerTitle"></header-title>

<section class="card mt-4" *ngIf="headerTitle && user && currentUser">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-user me-2"></i>{{ headerTitle.title }}</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <form (submit)="register()" #registerForm="ngForm">
                    <div class="">
                        <error-message [errors]="errors"></error-message>

                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Email
                                    </label>
                                    <h6>{{user.email}}</h6>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        First name
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{user.firstName}}</h6>
                                    <input *ngIf="isEditMode" type='text' class="form-control" [(ngModel)]="user.firstName" name="firstName" required #firstName="ngModel" />
                                    <div *ngIf="isEditMode && firstName?.errors && (firstName?.dirty || firstName?.touched || submitAttempt)">
                                        <label class="error" [hidden]="!firstName.errors.required">First name is a required field.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Last name
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{user.lastName}}</h6>
                                    <input *ngIf="isEditMode" class="form-control" [(ngModel)]="user.lastName" name="lastName" #lastName="ngModel" required />
                                    <div *ngIf="isEditMode && lastName?.errors && (lastName?.dirty || lastName?.touched || submitAttempt)">
                                        <label class="error" [hidden]="!lastName.errors.required">Last name is a required field.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 text-end">
                                <div class="form-group">
                                    <button *ngIf="isEditMode && !companies?.length" type="button" class="btn btn-danger mt-4" (click)="selectedUserId=user.id; confirmation.showMessage();">Delete User</button>
                                    <button *ngIf="isEditMode && companies?.length > 0" type="button" class="btn btn-danger mt-4" (click)="openCannotDeleteUser(cannotDeleteUser);">Delete User</button>

                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Phone Number
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{user.phoneNr}}</h6>
                                    <input *ngIf="isEditMode" type='text' class="form-control" [(ngModel)]="user.phoneNr" name="phoneNr" #phoneNr="ngModel" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Phone Number
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{user.mobileNr}}</h6>
                                    <input *ngIf="isEditMode" type='text' class="form-control" [(ngModel)]="user.mobileNr" name="mobileNr" #mobileNr="ngModel" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group" *ngIf="currentUser.isAdmin">
                                    <label class="control-label">
                                        Notes
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{user.notes}}</h6>
                                    <textarea *ngIf="isEditMode" class="form-control" [(ngModel)]="user.notes" name="notes"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Is Active
                                    </label>
                                    <input type="checkbox" id="isActive" name="isActive" class="form-control" [(ngModel)]="user.isActive" appToggle [isDisabled]="!isEditMode" />
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col">
                                        <h5 class="text-primary">Companies</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <app-user-company-list (userCompaniesUpdated)="userCompaniesUpdated()" [isEditMode]="isEditMode" [userId]="userId"></app-user-company-list>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="mt-3">
                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                <button class="btn btn-outline-primary me-2" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                <button class="btn btn-success ms-2" type="submit" *ngIf="isEditMode">Save</button>
                            </div>
                        </div>
                    </footer>
            </form>
        </div>
    </div>
</section>


<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'User updated!'">
</app-alert-message>

<app-confirmation-message #confirmation (confirmationClicked)="deleteUser();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this user?'">
</app-confirmation-message>

<ng-template #cannotDeleteUser let-modal>
    <div class="modal-header">
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="modal-title" id="modal-basic-title">Users with assigned Companies cannot be deleted.</h4>
                        </div>
                        <div class="col-12">
                            <p id="modal-basic-content">Remove all Companies to continue.</p>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
